import { Sortable } from '@moodys/cre-cpm-client-apis.apis.api-base';

export const defaultUnitFields = {
  asset: 'id',
  units: [
    'asset_ref_uuid',
    'normalized_address',
    'type_of_use',
    'area',
    'floor_number',
    'tenant_name',
    'lease_start_date',
    'lease_end_date',
    'walt',
    'rent_monthly',
    'term_service_charge',
    'country_code',
    'longitude',
    'latitude',
    'measured_by',
    'currency_code',
    'currency_exchange_rates',
    'rentroll_date',
    'source_portfolio_ref_id',
    'source_portfolio_name',
    'source_unit_ref_id',
    'source_asset_ref_id',
    'source_tenant_ref_id',
    'source_type_of_use',
    'type_of_use_2',
    'num_rooms',
    'part_of_building',
    'floor_number',
    'floor_location',
    'rented_status',
    'rented_status_terminated',
    'rented_status_termination_effective_date',
    'rent_vat',
    'rent_free_start_date',
    'rent_free_end_date',
    'rent_reduction',
    'rent_reduction_start_date',
    'rent_reduction_end_date',
    'term_opex',
    'term_heatex',
    'arrear_amount',
    'term_other_service_charges',
  ].join(','),
  tenants: [
    'name',
    'ref_ultimate_tenant_id',
    'ref_id',
    'ref_type',
    'country_code',
    'total_area',
    'total_net_rent_monthly',
    'walt',
    'total_units',
    'esg_global_score',
    'industry_primary_label',
    'legal_entity_identifier',
    'naics_core_label',
    'naics_primary_label',
    'naics_secondary_label',
    'sic_core_label',
    'sic_primary_label',
    'sic_secondary_label',
    'employee_count',
    'cortera_payment_rating_score',
    'operating_revenue',
    'p_l_before_tax',
    'p_l_for_period',
    'cash_flow',
    'total_assets',
    'shareholders_funds',
    'current_ratio',
    'profit_margin',
    'roe_using_p_l_before_tax',
    'roce_using_p_l_before_tax',
    'solvency_ratio',
    'measured_by',
  ].join(','),
};

export const defaultUnitSort: Sortable = {
  fieldName: 'created_at',
  fieldOrder: 'descend',
};
